import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { userSetsSectionThunk } from "../../store/thunks";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { trackAdobeClick } from "../../utils/adobeLogging";
import LanguageSwitcher from "../common/LanguageSwitcher";

const Footer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const currentSection = useSelector((state) => state.progress.section);
  const progress = useSelector((state) => state.progress);
  const lang = useSelector((state) => state.ui.lang);
  const logoUrl = useSelector((state) => {
    let result = "images/kickoff.png";
    if (state.config.logos && state.affiliate.org) {
      return state.config.logos[state.affiliate.org]
        ? state.config.logos[state.affiliate.org]
        : result;
    }
    return result;
  });
  const { t } = useTranslation();

  const sectionLabel =
    currentSection === "PMAgile" ? (
      <span>
        <span>{t("switchToWaterfall")}</span>
      </span>
    ) : (
      <span>
        <span>{t("switchToAgile")}</span>
      </span>
    );

  const toggleSection = async () => {
    const nextSection =
      currentSection === "PMAgile" ? "PMWaterfall" : "PMAgile";
    await dispatch(userSetsSectionThunk(nextSection));
    const sectionName = nextSection === "PMAgile" ? "agile" : "waterfall";

    trackAdobeClick(null, {
      linkTitle:
        currentSection === "PMAgile"
          ? t("switchToWaterfall")
          : t("switchToAgile"),
      linkModule: `${currentSection}-footer`,
      targetURL: progress.currentPosition[lang][sectionName + "Path"],
    });

    return history.push(progress.currentPosition[lang][sectionName + "Path"]);
  };

  return (
    <>
      <footer
        style={{
          minHeight: "35px",
          width: "100%",
        }}
        adoberegion={`${currentSection}-footer`}
      >
        <div
          className="mt-5 px-3 lg:px-0 flex lg:justify-between items-center text-sm"
          style={{ minHeight: "35px" }}
        >
          <div>
            <LanguageSwitcher />
          </div>
          <div>{t("copyright")}</div>
        </div>
      </footer>
      <div className="w-full flex justify-end">
        <div className="w-24">
          <img src={logoUrl} alt="baseline-beta" />
        </div>
      </div>
    </>
  );
};

export default Footer;
